module.exports = __webpack_public_path__ + "static/media/empty-projects.69da6166.svg";